import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=9dccac0a&lang=pug"
import script from "./footprint.vue?vue&type=script&lang=js"
export * from "./footprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports